import mutations from './mutations'
import getters from './getters'

const state = {
  selectedSource: '',
  // logo的信息
  LogoMessage: {},
  // 通过websocket获取的设备信息
  WSGetFacility: []
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
